import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Chip, Divider, Grid, Menu, MenuItem, TextField, Tooltip } from '@mui/material';
import { Add, Check, Delete, Edit } from '@mui/icons-material';
import Button from '@mui/material/Button';
import { DeleteLabelModal } from '~/components/dashboard/DeleteLabelModal';
import "@fontsource/lato";
import ReactTooltip from "react-tooltip";
export const Labels = (props) => {
    const { patient, availableLabels, labelUpdated, isDashboard } = props;
    const [showAddLabel, setShowAddLabel] = useState(false);
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    const [labelAnchorEl, setLabelAnchorEl] = React.useState(null);
    const addLabelOpen = Boolean(labelAnchorEl);
    // const [filteredLabels, setFilteredLabels] = useState<ICustomLabels[]>(availableLabels);
    const [patientLabels, setPatientLabels] = useState(patient.customLabels);
    const [assignableLabels, setAssignableLabels] = useState(availableLabels);
    const [filteredLabels, setFilteredLabels] = useState(assignableLabels);
    // const [popperAnchorEl, setPopperAnchorEl] = React.useState<null | HTMLLIElement | HTMLButtonElement>(null);
    const [selectedColor, setSelectedColor] = useState('');
    const [hoveredItem, setHoveredItem] = useState('');
    const [labelToEdit, setLabelToEdit] = useState(null);
    const [newLabelValue, setNewLabelValue] = useState('');
    const inputEl = useRef(null);
    const [searchInputValue, setSearchInputValue] = useState('');
    useEffect(() => {
        setAssignableLabels(availableLabels);
        setFilteredLabels(availableLabels);
    }, [availableLabels]);
    const handleAddLabelMenuClick = (event) => {
        setLabelAnchorEl(event.currentTarget);
        setShowAddLabel(true);
    };
    const handleCloseAddLabel = () => {
        setLabelAnchorEl(null);
        setShowAddLabel(false);
    };
    const handleLabelClick = async (label) => {
        if (label) {
            const labelIndex = patientLabels.map(e => e.labelName).indexOf(label.labelName);
            if (labelIndex !== -1) {
                handleRemoveLabel(patientLabels[labelIndex].labelId);
            }
            else {
                const response = await axios.post('/api/patient/addLabelToPatient', {
                    patient_id: patient.id,
                    label_id: label.id
                });
                label.labelId = response.data.data.new_label.label_id;
                patientLabels.push(label);
                setPatientLabels(patientLabels);
            }
        }
        handleCloseAddLabel();
        ReactTooltip.rebuild();
    };
    const handleRemoveLabel = async (labelId) => {
        await axios.post('/api/patient/removeLabelFromPatient', {
            patient_id: patient.id,
            label_id: labelId
        });
        const newLabels = patientLabels.filter((labels) => labels.labelId !== labelId);
        setPatientLabels(newLabels);
        patient.customLabels = [];
        for (const el of newLabels) {
            patient.customLabels.push(el);
        }
        ReactTooltip.rebuild();
    };
    const handleSaveLabel = async () => {
        if (labelToEdit) {
            // Update existing label
            await axios.post('/api/labels/editLabel', {
                label_id: labelToEdit.id,
                label_name: newLabelValue,
                label_color: selectedColor
            });
            labelToEdit.labelName = newLabelValue;
            labelToEdit.labelColor = selectedColor;
            labelUpdated(labelToEdit);
            setIsEditOpen(false);
            setSelectedColor('');
            setNewLabelValue('');
            setLabelToEdit(null);
            alert('Label updated. Please reload the page to refresh labels');
            window.location.reload();
        }
        else {
            if (selectedColor === '') {
                setSelectedColor('#2C78EB');
            }
            // Add a new label
            const response = await axios.post('/api/labels/createNewLabel', {
                label_name: newLabelValue,
                label_color: selectedColor,
                practice_id: patient.practiceId
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            const label = response.data.data.new_label;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            label.labelName = response.data.data.new_label.label_name;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            label.labelColor = response.data.data.new_label.label_color;
            assignableLabels.push(label);
            setAssignableLabels(assignableLabels);
            handleLabelClick(label);
            setIsEditOpen(false);
            setSelectedColor('');
            setNewLabelValue('');
            setLabelToEdit(null);
        }
    };
    const handleChangeLabel = (value) => {
        setNewLabelValue(value);
    };
    const handleSearchInputChange = (value) => {
        setSearchInputValue(value);
        if (value === '') {
            setFilteredLabels(assignableLabels);
        }
        else {
            const newFilteredValues = assignableLabels.filter((label) => label.labelName.toLowerCase().includes(value.toLowerCase()));
            setFilteredLabels(newFilteredValues);
        }
    };
    return (React.createElement(React.Fragment, null,
        patientLabels.length === 0 && React.createElement(Chip, { style: { padding: 5, fontFamily: 'Barlow', borderRadius: 6, fontWeight: 600 }, size: 'small', color: 'primary', variant: 'outlined', label: 'Add Label', onClick: (event) => handleAddLabelMenuClick(event) }),
        React.createElement("div", { style: { display: 'inline-flex', width: isDashboard ? '' : '90%' } },
            (patientLabels.length > 0) && React.createElement(Chip, { style: { marginTop: 'auto', marginBottom: 'auto', borderRadius: 6, marginRight: 5 }, label: "+", color: "primary", size: "small", variant: "outlined", onClick: (event) => handleAddLabelMenuClick(event) }),
            React.createElement("div", { style: { display: isDashboard ? 'grid' : '', margin: isDashboard ? 'auto' : '0px', width: isDashboard ? '' : '75%' } }, isDashboard ? (patientLabels.map((label, index) => (index < 2 &&
                React.createElement(Chip, { key: label.id, size: 'small', color: 'primary', variant: 'filled', label: label.labelName, style: { padding: 5, fontFamily: 'Barlow', borderRadius: 6, backgroundColor: label.labelColor, marginBottom: patientLabels.length === 1 ? '0px' : '5px', marginLeft: 'auto', marginRight: 'auto', width: 'fit-content' }, onDelete: () => handleRemoveLabel(label.labelId), onClick: (event) => handleAddLabelMenuClick(event) })))) : (patientLabels.map((label, index) => (index < 2 &&
                React.createElement(Tooltip, { title: label.labelName },
                    React.createElement(Chip, { key: label.id, size: 'small', color: 'primary', variant: 'filled', label: label.labelName, sx: {
                            maxWidth: '90%',
                            padding: '5px',
                            fontFamily: 'Barlow',
                            borderRadius: '6px',
                            backgroundColor: label.labelColor,
                            marginBottom: patientLabels.length === 1 ? '0px' : '5px',
                            marginTop: 'auto',
                            marginLeft: '2px',
                            marginRight: '2px',
                            width: '90%',
                            height: 20,
                            '& .MuiChip-label': {
                                marginRight: 'auto'
                            }
                        }, onDelete: () => handleRemoveLabel(label.labelId), onClick: (event) => handleAddLabelMenuClick(event) })))))),
            patientLabels.length > 2 && (React.createElement("div", { style: { cursor: 'pointer', color: '#2C78EB', fontSize: 13, fontFamily: 'Barlow', fontWeight: '600', marginTop: 'auto', marginBottom: 'auto', marginLeft: 5 }, "data-tip": true, "data-for": patient.id },
                "+",
                patientLabels.length - 2)),
            React.createElement(ReactTooltip, { id: patient.id, place: "right", backgroundColor: '#FFFFFF' },
                React.createElement("div", { style: { display: 'grid', width: 'fit-content' } }, patientLabels.map((label, index) => (index > 1 &&
                    React.createElement(Chip, { key: label.id, size: 'small', color: 'primary', variant: 'filled', label: label.labelName, style: { padding: 5, fontFamily: 'Barlow', borderRadius: 6, backgroundColor: label.labelColor, marginBottom: patientLabels.length === 1 ? '0px' : '5px', width: 'fit-content' } })))))),
        showAddLabel && (React.createElement(React.Fragment, null,
            React.createElement(Menu, { id: "labels-menu", anchorEl: labelAnchorEl, open: addLabelOpen, onClose: handleCloseAddLabel },
                React.createElement(TextField, { onKeyDown: (event) => event.stopPropagation(), type: "search", style: { marginLeft: '10px', marginRight: '10px' }, label: "Search Label", variant: "outlined", size: "small", value: searchInputValue, onChange: (val) => handleSearchInputChange(val.currentTarget.value) }),
                React.createElement("div", { style: { maxHeight: '150px', overflow: 'scroll' } }, filteredLabels.map((label) => (React.createElement(MenuItem, { onMouseEnter: () => setHoveredItem(label.labelName), onMouseLeave: () => setHoveredItem('') },
                    React.createElement(Chip, { size: 'small', color: 'primary', variant: 'filled', label: label.labelName, style: { padding: 5, backgroundColor: label.labelColor, fontFamily: 'Barlow', borderRadius: 6 }, onClick: () => handleLabelClick(label) }),
                    React.createElement("div", { style: { float: 'right', marginLeft: 'auto' } },
                        patientLabels.some(item => label.labelName === item.labelName) && React.createElement(Check, { color: "primary", fontSize: "small" }),
                        hoveredItem === label.labelName &&
                            React.createElement(Button, { style: { padding: '0', minWidth: '0px', minHeight: '0px', height: '15px', width: '15px', borderRadius: '50%' }, variant: 'contained', onClick: () => {
                                    setLabelToEdit(label);
                                    setSelectedColor(label.labelColor);
                                    setIsEditOpen(true);
                                    setNewLabelValue(label.labelName);
                                    // setPopperAnchorEl(event.currentTarget);
                                } },
                                React.createElement(Edit, { style: { fontSize: 'x-small' } }))))))),
                React.createElement(Divider, null),
                React.createElement(MenuItem, { ref: inputEl, onClick: () => {
                        setIsEditOpen(true);
                        // setPopperAnchorEl(event.currentTarget);
                    } },
                    React.createElement(Add, { style: { color: '#00000054', fontFamily: 'Barlow' } }),
                    " Add Label")),
            isEditOpen &&
                React.createElement(Menu, { onClose: () => {
                        setIsEditOpen(false);
                        setLabelToEdit(null);
                    }, anchorEl: inputEl.current, open: isEditOpen, anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'right',
                    }, transformOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                    } },
                    React.createElement("div", { style: { width: '100%', paddingLeft: '10px', paddingBottom: '10px', color: 'black', fontSize: 16, fontFamily: 'Barlow', fontWeight: 600 } }, labelToEdit ? 'Edit Label' : 'Add Label'),
                    React.createElement(Divider, null),
                    React.createElement(TextField, { onKeyDown: (event) => event.stopPropagation(), style: { width: '100%', padding: '10px', marginRight: 'auto', marginLeft: 'auto', fontFamily: 'Barlow' }, label: "Label", variant: "outlined", defaultValue: labelToEdit && labelToEdit.labelName, size: "small", onChange: (val) => handleChangeLabel(val.currentTarget.value) }),
                    React.createElement(Grid, { sx: { padding: '10px', width: 250 }, container: true, rowSpacing: 0.5, columnSpacing: 0.5 }, colorOptions.map((color) => (React.createElement(Grid, { key: color.color, item: true, xs: 2, onClick: () => setSelectedColor(color.color) },
                        React.createElement("div", { style: {
                                width: '25px',
                                height: '25px',
                                position: 'relative',
                                background: color.color,
                                borderRadius: 6,
                                borderColor: selectedColor === color.color ? '#FFB400' : '',
                                borderWidth: selectedColor === color.color ? 'medium' : '',
                                cursor: 'pointer'
                            } }))))),
                    React.createElement(Divider, null),
                    React.createElement("div", { style: { padding: '10px' } },
                        React.createElement(Delete, { style: { color: '#D32F2F', cursor: 'pointer' }, onClick: () => {
                                if (labelToEdit) {
                                    setIsDeleteOpen(true);
                                }
                            } }),
                        React.createElement("div", { className: "float-right" },
                            React.createElement(Button, { style: { marginRight: '10px', fontFamily: 'Barlow', fontWeight: 700, fontSize: 13 }, size: "small", variant: "outlined", color: "primary", onClick: () => {
                                    setIsEditOpen(false);
                                    setLabelToEdit(null);
                                } }, "Cancel"),
                            React.createElement(Button, { style: { fontFamily: 'Barlow', fontWeight: 700, fontSize: 13 }, size: "small", variant: "contained", color: "primary", onClick: handleSaveLabel }, "Save")))))),
        isDeleteOpen && (React.createElement(DeleteLabelModal, { onRequestClose: () => {
                assignableLabels.filter((labels) => labels.labelId !== labelToEdit?.labelId);
                setIsDeleteOpen(false);
                setLabelToEdit(null);
                setIsEditOpen(false);
                setSelectedColor('');
                setNewLabelValue('');
            }, labelToEdit: labelToEdit }))));
};
const colorOptions = [
    {
        color: '#2C78EB'
    },
    {
        color: '#018FB7'
    },
    {
        color: '#6200EA'
    },
    {
        color: '#FB42FF'
    },
    {
        color: '#424242'
    },
    {
        color: '#C51162'
    },
    {
        color: '#1A237E'
    },
    {
        color: '#EF6C00'
    },
    {
        color: '#2E7D32'
    },
    {
        color: '#FF3D00'
    },
    {
        color: '#017292'
    },
    {
        color: '#7986CB'
    },
];
